import { formatDistanceToNow } from 'date-fns';
import fallbackImg from "../../assets/user.png"; // Import the fallback image


// Function to format Firestore timestamp to "time ago" format
export const formatDate = (timestamp) => {
  const date = timestamp.toDate(); // Convert Firestore Timestamp to JavaScript Date object
  return formatDistanceToNow(date, { addSuffix: true }); // Format date to "time ago" format
};

export const userColumns = [
  { 
    field: "id",
    headerName: "ID",
    width: 200 
  },
  {
    field: "image",
    headerName: "Image",
    width: 30,
    renderCell: (params) => {
      const imgSrc = params.row.image || fallbackImg; // Use fallback image if img is null
      return (
        <div className="cellWithImg">
          <img
            className="cellImg"
            src={imgSrc}
            onError={(e) => (e.target.src = fallbackImg)} // Fallback on error
          />
        </div>
      );
    },
  },
  { 
    field: "gift_name",
    headerName: "Gift Name",
    width: 150 
  },
  { 
    field: "amount",
    headerName: "Amount",
    width: 129 
  },
  { 
    field: "contest_id",
    headerName: "Contest id",
    width: 200 
  },
  {
    field: "position",
    headerName: "Position",
    width: 100,
  },
  {
    field: "timestamp",
    headerName: "Timestamp",
    width: 150,
    valueGetter: (params) => formatDate(params.value), // Use valueGetter to format createdAt field
  },
];
